import { useEffect, useState } from "react";
import AppButton from "../buttons/app-button/app-button";
import styles from "./search.module.scss";
interface IProps {
  handleSearchChange: (searchText: string) => void;
  onSearch: () => void;
  placeholder: string;
  value: string;
  isWithOptions?: boolean;
}

const Search = (props: IProps) => {
  const { handleSearchChange, onSearch, placeholder, isWithOptions, value } =
    props;
  const [firstTime, setFirstTime] = useState(true);

  useEffect(() => {
    if (!value && !firstTime) {
      onSearch();
      return;
    }

    setFirstTime(false);
  }, [value]);

  return (
    <div
      className={`${
        !isWithOptions
          ? styles[`search-wrapper`]
          : styles[`search-wrapper-style-two`]
      }`}
    >
      <input
        type="text"
        placeholder={placeholder}
        value={value}
        onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
          handleSearchChange(e.target.value);
        }}
        onKeyDown={(e: React.KeyboardEvent<HTMLInputElement>) => {
          if (e.key === "Enter") {
            e.preventDefault();
            onSearch();
          }
        }}
        className={`${styles[`search-input`]} w-100`}
      />
      <AppButton
        text="Search"
        iconName="search"
        iconColor="#FFFFFF"
        iconOnly
        size="medium"
        onClick={() => {
          onSearch();
        }}
        type="button"
        className={styles.searchButton}
        style={{ backgroundColor: "#2f2a89" }}
      />
    </div>
  );
};

export default Search;
